import { storage } from "../../consts";
import { stringUtil } from "../../utils";

const setMarketToStorage = (market) => {
  localStorage.setItem(storage.MARKET, market);
};

const getMarketFromStorage = () => localStorage.getItem(storage.MARKET);

const removeMarketFromStorage = () => {
  localStorage.removeItem(storage.MARKET);
};
const setUserClaimsToStorage = (claims) =>
  sessionStorage.setItem(storage.USER_CLAIMS, stringUtil.toBase64(claims));
const getUserClaimsFromStorage = () =>
  stringUtil.fromBase64(sessionStorage.getItem(storage.USER_CLAIMS));

const getIsDarkMode = () => localStorage.getItem(storage.DARK_MODE);
const setIsDarkMode = (value) => localStorage.setItem(storage.DARK_MODE, value);

const setAppTypeToStorage = (market) => {
  localStorage.setItem(storage.APP_TYPE, market);
};

const getAppTypeFromStorage = () => localStorage.getItem(storage.APP_TYPE);

const removeAppTypeFromStorage = () => {
  localStorage.removeItem(storage.APP_TYPE);
};

const storageService = {
  setMarketToStorage,
  getMarketFromStorage,
  removeMarketFromStorage,
  setUserClaimsToStorage,
  getUserClaimsFromStorage,
  getIsDarkMode,
  setIsDarkMode,
  setAppTypeToStorage,
  getAppTypeFromStorage,
  removeAppTypeFromStorage,
};

export default storageService;
